<template>
    <div v-if="mostrar" class="modal-mask" @click="$emit('fechar')">
        <div class="jm modal-editar-inner" @click.stop>
            <div>
                <div style="display: flex; justify-content: space-between">
                    <h3>Editar: {{ localPlano.nome }} </h3>
                </div>
                <hr>
                <br>
                <div class="grid-2">
                    <div>
                        <label>Assunto</label>
                        <input type="text" v-model="localPlano.nome" @focusout="emitEditar('nome', localPlano.nome)">
                    </div>
                    <div>
                        <label>Gerente Responsável</label>
                        <select v-model="localPlano.gerente_id" @change="emitEditar('gerente_id', localPlano.gerente_id)">
                            <option v-for="item in gerente" :key="item.id" :value="item.id">
                                {{ item.nomeCompleto }}
                            </option>
                        </select>
                    </div>
                    <div>
                        <label>Data de Início</label>
                        <input type="date" v-model="localPlano.dtInicio"
                            @change="emitEditar('dtInicio', localPlano.dtInicio)">
                    </div>
                    <div>
                        <label>Data de Término</label>
                        <input type="date" v-model="localPlano.dtTermino"
                            @change="emitEditar('dtTermino', localPlano.dtTermino)">
                    </div>
                    <div>
                        <label>Setor Beneficiado</label>
                        <select v-model="localPlano.setor_id" @change="emitEditar('setor_id', localPlano.setor_id)">
                            <option v-for="item in setores" :key="item.id" :value="item.id"
                                :style="{ 'font-weight': (item.nivel_hierarquico <= 2) ? 'bold' : '0' }">
                                <span v-if="item.nivel_hierarquico == 3" style="color: red;"> &nbsp;&nbsp; </span>
                                {{ item.nivel_hierarquico == 3 ? "-" : "" }} {{ item.nome }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalEditarPlanoPAP",
    props: {
        mostrar: { type: Boolean, default: false },
        plano: { type: Object, required: true },
        gerente: { type: Array, default: () => [] },
        setores: { type: Array, default: () => [] },
    },
    emits: ["fechar", "editar"],
    data() {
        return {
            localPlano: { nome: "", gerente_id: "", dtInicio: "", dtTermino: "", setor_id: "" },
        };
    },
    watch: {
        mostrar(visivel) {
            if (visivel && this.plano) {
                this.localPlano = { ...this.plano };
            }
        },
        plano: {
            handler(val) {
                if (val && this.mostrar) {
                    this.localPlano = { ...val };
                }
            },
            deep: true,
        },
    },
    methods: {
        emitEditar(campo, valor) {
            this.$emit("editar", campo, valor);
        },
    },
};
</script>

<style scoped>
.modal-editar-inner {
    overflow: auto;
    height: 70%;
    width: 50rem;
    padding: 2rem;
    margin-bottom: 3rem;
}
</style>
